import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Calendar } from 'primeng/calendar';

@Component({
  selector: 'app-custom-calendar',
  templateUrl: './custom-calendar.component.html',
  styleUrls: ['./custom-calendar.component.scss'],
})
export class CustomCalendarComponent {
  @Input() queryModel: any;
  @Input() calendarType: any;
  /** Hides the in-panel Reset shortcut. Defaults on, so existing callers are unaffected. */
  @Input() showReset = true;
  maxFromDate: any = new Date();
  minFromDate: any;
  maxToDate: any = new Date();
  minToDate: any;
  hide: boolean = true;
  showFromDateWarning: boolean = false;
  showToDateWarning: boolean = false;
  @ViewChild('primeCalendar') calendar!: Calendar;

  ngOnInit() {
    this.hide = false;
  }

  setMinMaxDate() {
    if(this.queryModel.fromDate){
      this.minToDate = new Date(this.queryModel.fromDate);
    }
    if(this.queryModel.toDate){
      this.maxFromDate = new Date(this.queryModel.toDate)
    }
  }

  setDay() {
    const today = new Date();
    this.queryModel.fromDate = this.formatDate(today);
    this.queryModel.toDate = this.formatDate(today);
    this.calendar.overlayVisible = true;
  }

  setDays(count: number) {
    const currentDate = new Date();
    const startDate = new Date(
      currentDate.getTime() - count * 24 * 60 * 60 * 1000
    );
    this.queryModel.fromDate = this.formatDate(startDate);
    this.queryModel.toDate = this.formatDate(currentDate);
    this.calendar.overlayVisible = true;
  }

  reset() {
    this.queryModel.fromDate = null;
    this.queryModel.toDate = null;
    this.calendar.overlayVisible = true;
  }
  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  // Emit an event when the calendar is clicked
  @Output() calendarClick = new EventEmitter<void>();


  // Method to handle date selection
  onDateSelected() {
    // Emit the select event
    this.calendarClick.emit();
  }

  // Method to handle calendar click event
  calendarClicked(event: Event): void {
    // Emit the event to prevent the filter dialogue from closing
    this.calendarClick.emit();
    this.checkDateValidation();
    event.stopPropagation();
  }
  checkDateValidation() {
    if (this.queryModel.fromDate && !this.queryModel.toDate) {
      this.showFromDateWarning = false;
      this.showToDateWarning = true;
    } else if (!this.queryModel.fromDate && this.queryModel.toDate) {
      this.showFromDateWarning = true;
      this.showToDateWarning = false;
    } else {
      this.showFromDateWarning = false;
      this.showToDateWarning = false;
    }
  }
}
